<template>
  <section class="content">
    <div>
      <div id="overlay" v-if="loading">
        <div class="spinner"></div>
        <br/>
        <h4>Loading...</h4>
      </div>
      <div class="box box-info">
        <form>
          <div class="p-fluid p-formgrid p-grid p-mt-2">
            <div class="p-field p-col-12 p-md-2">
              <label for="purchaseSalesDate">Purchase Date</label>
              <date-picker ref="tran" v-model="purchaseSalesDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" ref="tran" type="text" v-else class="nepali-calendar" id="purchaseSalesDate"
                         v-model="purchaseSalesDate"/>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label for="returnNo">Return No</label>
              <InputText id="returnNo" v-model="returnNo" disabled/>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label for="refno">Reference No</label>
              <InputText id="refno" v-model="referenceNumber"/>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label for="paymentType">Vat Type</label>
              <select class="form-control" v-model="taxType">
                <option selected disabled value="">Select VatType</option>
                <option v-for="(tax,ind) in taxTypeList" :key="ind">{{ tax.name }}</option>
              </select>
            </div>
          </div>
          <div class="p-fluid p-formgrid p-grid p-mt-2">
            <div class="p-field p-col-12 p-md-3">
              <label>Purchase From</label>
              <Dropdown
                v-model="accountMaster"
                :options="supplierCustomerCashList"
                optionLabel="name"
                :filter="true"
                placeholder="Select Account"
                :showClear="true"
              />
              <!--                {{accountMaster}}-->
            </div>
            <div class="p-field p-col-12 p-md-2" v-if="ifCash">
              <label>Vendor</label>
              <InputText placeholder="Vendor Name" v-model="vendorName"/>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label for="warehouse">Store</label>
              <Dropdown
                v-if="!setWarehouseData"
                v-model="warehouse"
                :options="warehouseLists"
                optionLabel="name"
                class="dropDown"
                :filter="true"
                placeholder="Select Warehouse"
                :showClear="true"
              />
              <Dropdown
                v-else
                v-model="warehouse"
                :options="warehouseLists"
                optionLabel="name"
                id="warehouse"
                :filter="true"
                placeholder="Select warehouse"
                :disabled="true"
              />
            </div>

          </div>
          <div class="p-fluid p-formgrid p-grid p-mt-2" v-if="!ifNotCash">
            <div class="p-field p-col-12 p-md-2">
              <label for="panNo">Cur. Bal.</label>
              <b style="color:red;" v-if="accountMaster.closingBalance>0">
                {{ (accountMaster.closingBalance).toFixed(2) + 'Cr' }}
              </b>
              <b style="color:green;" v-else>
                {{ (accountMaster.closingBalance * (-1)).toFixed(2) + 'Dr' }}
              </b>
            </div>
            <!--                <div class="col-md-2 address">-->
            <!--                  <label for="address">Contact Name</label>-->
            <!--                  <b>{{accountMaster.contactName}}</b>-->
            <!--                </div>-->
            <div class="p-field p-col-12 p-md-2">
              <label for="panNo">Pan No: </label>
              <b>{{ accountMaster.panNo }}</b>
            </div>
          </div>

          <div class="p-fluid p-formgrid p-grid p-mt-2">
            <div class="p-field p-col-12 p-md-2">
              <label for="itm">Item<span style="color:red">*</span></label>
              <!-- <Dropdown
                v-model="items"
                :options="itemMasterListByItemType"
                optionLabel="name"
                class="dropDown"
                :filter="true"
                placeholder="Select One"
              /> -->
              <AutoComplete v-model="items" filterMatchMode='contains'
                            :suggestions="filteredItems" @complete="searchItem($event)"
                            field="name" ref="itm">
                <template #item="slotProps">
                  <div style="font-size: 12px !important;">{{ slotProps.item.name }} - {{ slotProps.item.itemCode }}</div>
                </template>
              </AutoComplete>
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="qty">Return Qty</label>
              <!-- <input type="text" class="form-control" id="qty" @keypress="isNumber(event)" v-model="quantity"/> -->
              <InputNumber id="minmaxfraction" v-model="quantity" onfocus="if (this.value === '0.00'){this.value = ''
}" :minFractionDigits="2" :maxFracionDigits="4"/>
            </div>
            <div class="p-field p-col-12 p-md-1">
              <label for="qty">Unit</label>
              <InputText v-model="items.unitName" disabled/>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label class="col-sm-2" for="rate">Rate</label>
              <!-- <input type="text" class="form-control" id="rate" @keypress="isNumber(event)"  v-model="rate"/> -->
              <InputNumber id="minmaxfraction" onfocus="if (this.value === '0.00'){this.value = ''
}" v-model="rate" :minFractionDigits="2" :maxFracionDigits="4"/>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label for="total">Total</label>
              <!-- <input  class="form-control" id="total" @keypress="isNumber(event)" v-model="total"/> -->
              <InputNumber disabled id="minmaxfraction" onfocus="if (this.value === '0.00'){this.value = ''
}" v-model="total" :minFractionDigits="2" :maxFracionDigits="4"/>
            </div>
            <div class="p-field p-col-12 p-md-1 p-mt-5">
              <Button class="p-button-raised p-button-rounded" @click.prevent="addItemToDTOList"
                      :label="editDTO?'Update':'Add'"/>
            </div>
            <div class="p-field p-col-12 p-md-1 p-mt-5">
              <Button class="p-button-raised p-button-danger" @click.prevent="itemDTOreset"
                      v-if="editDTO" label="Cancel"/>
            </div>
          </div>
          <div style="display:none">{{ totalAmount }}{{ findRate }}</div>
          <div class="p-field p-col-12 p-md-2" v-if="items.closingStock >=0">
            <label for="avl">Cur. Qty:</label>
            <span>{{ items.closingStock }}</span>
          </div>
        </form>
        <div class="p-field p-col-12 p-md-12">
          <div class="row">
            <div class="scrollable">
              <table class="table table-bordered ">
                <thead>
                <tr>
                  <th scope="col">SN</th>
                  <th scope="col">Item Name</th>
                  <th scope="col">Quantity</th>
                  <th scope="col">Rate</th>
                  <th scope="col">Amount</th>
                  <th scope="col">Action</th>
                </tr>
                </thead>
                <tbody v-for="(item,index) in inventoryInOutDetailList " :key="index">
                <tr>
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.itemMaster.name }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>{{ item.rate }}</td>
                  <td>{{ item.rate * item.quantity }}</td>
                  <td>
                    <Button class="p-button-raised p-button-success"
                            @click="editItemFromDTO(item, index)" icon="pi pi-pencil"/>
                    <Button class="p-button-raised p-button-danger" v-if="editDTO"
                            @click="removeItemFromDTO(item, index)" disabled icon="pi pi-trash"/>
                    <Button class="p-button-raised p-button-danger" v-else-if="!editDTO"
                            @click="removeItemFromDTO(item, index)" icon="pi pi-trash"/>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <hr>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-12 p-md-3">
                <b style="margin-left: 15em;">Total:</b>
              </div>
              <div class="p-field p-col-12 p-md-3">
                <b style="margin-left: 16em;">{{ totalQty }}</b>
              </div>
              <div class="p-field p-col-12 p-md-3">
                <b style="margin-left: 16em;">{{ subTotal }}</b>
              </div>
            </div>
            <hr>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-3">
            <label>Narration</label>
            <Textarea rows="6" v-model="narration"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <table style="border: 1px solid #c8c8c8;">
              <thead>
              <tr>
                <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Subtotal</th>
                <th></th>
                <td style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">{{ subTotal }}</td>
              </tr>
              <tr>
                <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Discount</th>
                <Button v-if="chooseDiscountPer" @click="chooseDisPercent" label="%"/>
                <Button v-if="chooseDiscountAmt" @click="chooseDisountAmt" label="RS"/>
                <td style="border: 1px solid #c8c8c8;padding: 0px 0em 0px;">
                  <InputText onfocus="if (this.value === '0'){this.value = ''
}" v-if="chooseDiscountPer" v-model="discountPer"/>
                  <InputText onfocus="if (this.value === '0'){this.value = ''
}" v-if="chooseDiscountAmt" v-model="discountAmt"/>
                </td>
              </tr>
              <tr v-if="chooseDiscountPer">
                <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Discounted Amt:</th>
                <th></th>
                <td style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">{{ discountAmt }}</td>
              </tr>
              <tr>
                <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Taxable</th>
                <th></th>
                <td style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">{{ taxable }}</td>
              </tr>
              <tr>
                <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Non-taxable</th>
                <th></th>
                <td style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">{{ nonTaxable }}</td>
              </tr>
              <tr>
                <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Tax</th>
                <th>13%</th>
                <td style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">{{ tax }}</td>
              </tr>
              <tr>
                <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Total</th>
                <th></th>
                <td style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">{{ totalBillAmount }}</td>
              </tr>
              </thead>
            </table>
          </div>

          <div class="p-field p-col-12 p-md-3">
            <label>Reason<b style="color:red">*</b></label>
            <Textarea rows="6" v-model="returnReason"/>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-6"></div>
          <div class="p-field p-col-12 p-md-1">
            <Button icon="pi pi-save" class="p-button-raised p-button-success"
                    @click="addPurchaseReturn"
                    :label="editing?'Update':'Save'"/>
          </div>
          <div class="p-field p-col-12 p-md-1" v-if="purchaseReturn===undefined">
            <Button icon="pi pi-refresh" class="p-button-raised p-button-warning" @click="reset"
                    label="Reset"/>
          </div>
          <div class="p-field p-col-12 p-md-1" v-if="purchaseReturn!=undefined">
            <Button class="p-button-raised p-button-danger" @click="goBack()" label="Cancel"/>
          </div>
          <div class="p-field p-col-12 p-md-1">
            <Button class="p-button-raised p-button-secondary" label="Print" icon="pi pi-print"/>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <Button class="p-button-raised p-button-secondary" label="Generate PDF"
                    icon="pi pi-download"/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'

export default {
  name: 'purchaseReturn',
  props: ['purchaseReturn'],
  data() {
    return {
      name: '',
      warehouse: '',
      taxTypeList: [
        {name: 'Exclusive', code: 'Exclusive'},
        {name: 'Inclusive', code: 'Inclusive'},
        {name: 'Exempt', code: 'Exempt'}
      ],
      items: '',
      accountMaster: '',
      vendorName: '',
      quantity: 0,
      rate: 0,
      purchaseSalesDate: new Date().toISOString().slice(0, 10),
      inventoryInOutDetailList: [],
      inventoryInOutDetailDeleteList: [],
      taxType: '',
      taxable: 0,
      tax: 0,
      nonTaxable: 0,
      vatPercentage: '',
      purchaseMessage: '',
      id: null,
      returnNo: null,
      editing: false,
      editDTO: false,
      inventoryOutHeaderId: null,
      index: null,
      returnReason: '',
      itemSelected: '',
      loading: false,
      totalQty: 0,
      total: 0,
      filteredItems: null,
      discountPer: 0,
      discountAmt: 0,
      referenceNumber: 0,
      englishDateEnabled: true,
      narration: '',
      setWarehouseData: false,
      chooseDiscountPer: true,
      chooseDiscountAmt: false
    }
  },
  computed: {
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    },
    supplierCustomerCashList() {
      return this.$store.state.accountMaster.supplierCustomerCashList
    },
    itemMasterListByItemType() {
      return this.$store.state.itemMaster.itemMasterListByItemType
    },
    ifCash() {
      if (this.accountMaster.name === 'Cash' || this.accountMaster.name === 'cash') {
        return true
      }
    },
    ifNotCash() {
      if (this.accountMaster.name === 'Cash' || this.accountMaster === '') {
        return true
      }
    },
    findRate() {
      if (this.rate === 0) {
        if (this.total > 0 && this.quantity > 0) {
          let rates = 0
          rates = this.total / this.quantity
          if (isNaN(rates)) {
            rates = 0
          }
          this.rate = rates.toFixed(2)
          return rates
        }
      }
    },
    totalAmount() {
      if (this.quantity > 0 && this.rate > 0) {
        let totalAmt = 0
        totalAmt = parseFloat(this.quantity) * parseFloat(this.rate).toFixed(2)
        if (isNaN(totalAmt)) {
          totalAmt = 0
        }
        this.total = totalAmt
        return totalAmt
      }
    },
    subTotal() {
      let subTotal = 0
      let discountPerItem = 0
      let totalDiscountPerItem = 0
      this.discountAmt = 0
      this.taxable = 0
      this.tax = 0
      this.nonTaxable = 0
      this.totalQty = 0
      for (let i = 0; i < this.inventoryInOutDetailList.length; i++) {
        subTotal += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity))
        this.itemSelected = this.inventoryInOutDetailList[i].itemMaster
        this.totalQty += parseFloat(this.inventoryInOutDetailList[i].quantity)
        if (this.chooseDiscountPer === true) {
          if (this.discountPer > 100) {
            this.$toast.add({severity: 'error', summary: '', detail: 'Discount must be less than 100 %', life: 10000})
            return
          }
          this.discountAmt = (parseFloat(subTotal) * this.discountPer / 100).toFixed(4)
          discountPerItem = parseFloat(this.discountAmt) / parseFloat(this.totalQty)
        }
        if (this.chooseDiscountAmt === true) {
          if (this.discountAmt === '') {
            this.discountAmt = 0.0
          }
          discountPerItem = parseFloat(this.discountAmt) / parseFloat(this.totalQty)
        }
        switch (this.taxType) {
          case 'Exclusive':
            if (this.itemSelected.vatAble) {
              this.tax = 0
              totalDiscountPerItem = this.totalQty * discountPerItem
              this.taxable += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity) - parseFloat(totalDiscountPerItem))
              this.tax = parseFloat(this.taxable * 0.13).toFixed(2)
            } else {
              totalDiscountPerItem = this.totalQty * discountPerItem
              this.nonTaxable += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity) - parseFloat(totalDiscountPerItem))
            }
            break
          case 'Inclusive':
            if (this.itemSelected.vatAble) {
              let amtWithoutVat = ((subTotal * 100) / (100 + 13)).toFixed(2)
              this.taxable = parseFloat(amtWithoutVat)
              this.tax = (parseFloat(subTotal) - parseFloat(amtWithoutVat)).toFixed(2)
            } else {
              this.nonTaxable += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity))
            }
            break
          case 'Exempt':
            this.nonTaxable += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity))
            break
        }
      }
      return subTotal
    },
    totalBillAmount() {
      let totalBillAmount = 0
      totalBillAmount = parseFloat(this.taxable) + parseFloat(this.tax) + parseFloat(this.nonTaxable)
      return totalBillAmount
    }
  },
  mounted() {
    this.warehouseList()
    this.supplierCustomerList()
    this.maxPurchaseReturnNo()
    this.itemMasterListByItemTypes()
    if (this.purchaseReturn !== undefined) {
      this.editPurchaseReturn()
    }
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.purchaseReturn === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.setWarehouse()
  },
  methods: {
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    async supplierCustomerList() {
      await this.$store.dispatch('loadsupplierCustomerAndCashList')
    },
    async itemMasterListByItemTypes() {
      await this.$store.dispatch('loadItemMasterListByItemTypePurchase')
    },
    setWarehouse() {
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouse = this.$store.state.warehouseData
      } else if (this.warehouseLists.length === 1) {
        this.warehouse = this.warehouseLists[0]
      }
    },
    async maxPurchaseReturnNo() {
      let response = await this.$store.dispatch('maxPurchaseReturnNumber')
      if (this.purchaseReturn === undefined) {
        this.purchaseMessage = response.data.message
        this.returnNo = response.data.data
        this.narration = response.data.message + '- ' + response.data.data
      } else {
        this.purchaseMessage
        this.returnNo = this.purchaseReturn.returnNo
      }
    },
    addItemToDTOList() {
      let item = {
        itemId: this.items.id,
        itemMaster: this.items,
        quantity: this.quantity,
        rate: this.rate,
        id: this.id
      }
      if (this.taxType === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select purchase type!', life: 10000})
        return
      }
      if (this.accountMaster === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select vendor!', life: 10000})
        return
      }
      if (this.warehouse === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select store!', life: 10000})
        return
      }
      if (this.items.id === undefined) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Invalid item!', life: 10000})
        return
      }
      if (this.items === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select at least one item!', life: 10000})
        return
      } else if (this.quantity <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Quantity must be greater than 0!', life: 10000})
        return
      } else if (this.rate <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Rate must be greater than 0!', life: 10000})
        return
      } else {
        if (!this.editDTO) {
          this.inventoryInOutDetailList.push({...item})
        } else {
          this.inventoryInOutDetailList.splice(this.index, 1, {...item})
        }
      }
      this.itemDTOreset()
      this.focusInput()
    },
    editItemFromDTO(data, index) {
      this.itemDTOreset()
      this.editDTO = true
      this.items = data.itemMaster
      this.rate = data.rate
      this.quantity = data.quantity
      this.total = (parseFloat(data.rate) * parseFloat(data.quantity)).toFixed(2)
      this.index = index
      if (data.id !== undefined) {
        this.id = data.id
      }
    },
    async addPurchaseReturn() {
      if (this.purchaseSalesDate === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please enter date!', life: 10000})
        return
      }
      let response = ''
      let purchaseReturn = {
        returnNo: this.returnNo,
        warehouseId: this.warehouse.id,
        accountMasterId: this.accountMaster.id,
        purchaseSalesDate: this.purchaseSalesDate,
        purchaseSalesDateNepali: this.purchaseSalesDate,
        discountPercentage: this.discountPer,
        discount: this.discountAmt,
        referenceNumber: this.referenceNumber,
        fiscalYearId: this.$store.state.fyId,
        // vatTypeEnum: this.taxType.name,
        inventoryHeaderId: this.id,
        remarks: this.narration,
        billToName: this.vendorName,
        returnReason: this.returnReason,
        inventoryOutHeaderId: this.inventoryOutHeaderId,
        inventoryInOutDetailList: this.inventoryInOutDetailList,
        inventoryInOutDetailDeleteList: this.inventoryInOutDetailDeleteList,
        taxType: this.taxType,
        totalBillAmount: this.totalBillAmount
      }
      // // debugger
      if (purchaseReturn.inventoryInOutDetailList.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please add atleast one item!', life: 10000})
        return
      }
      if (this.returnReason === undefined) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Return reason cannot be empty!', life: 10000})
        return
      }
      if (!this.editing) {
        this.loading = true
        response = await this.$store.dispatch('addPurchaseReturn', purchaseReturn)
        this.loading = false
      } else {
        this.loading = true
        response = await this.$store.dispatch('updatePurchaseReturn', purchaseReturn)
        this.loading = false
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        await this.maxPurchaseReturnNo()
        this.reset()
        await this.itemMasterListByItemTypes()
        // this.focusAfterSave()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
        return
      }
    },
    editPurchaseReturn() {
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.purchaseSalesDate = this.purchaseReturn.purchaseSalesDateNepali
      } else {
        this.purchaseSalesDate = this.purchaseReturn.purchaseDate
      }
      this.inventoryInOutDetailList = this.purchaseReturn.inventoryInOutDetailList
      this.referenceNumber = this.purchaseReturn.referenceNumber
      this.purchaseMessage = this.purchaseReturn.remarks
      this.taxType = this.purchaseReturn.vatTypeEnum
      this.discountAmt = this.purchaseReturn.discount
      this.narration = this.purchaseReturn.remarks
      this.discountPer = this.purchaseReturn.discountPercentage
      this.warehouse = this.purchaseReturn.warehouse
      this.accountMaster = this.purchaseReturn.accountMaster
      this.inventoryOutHeaderId = this.purchaseReturn.id
      this.returnReason = this.purchaseReturn.returnReason
      this.editing = true
      this.id = this.purchaseReturn.id
      // // debugger
    },
    removeItemFromDTO(data, id) {
      if (this.editing && data.id !== null) {
        this.inventoryInOutDetailDeleteList.push({...data})
      }
      this.inventoryInOutDetailList.splice(id, 1)
    },
    itemDTOreset() {
      this.items = ''
      this.rate = 0
      this.quantity = 0
      this.total = 0
      this.editDTO = false
      this.id = null
    },
    reset() {
      this.itemDTOreset()
      this.warehouse = ''
      this.accountMaster = ''
      this.referenceNumber = ''
      this.taxType = ''
      this.inventoryInOutDetailList = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
      }
    },
    setNepaliDate() {
      if (this.purchaseReturn === undefined) {
        this.purchaseSalesDate = this.$store.getters.nepaliNewDate
      }
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    nepaliDate() {
      $('#purchaseSalesDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.purchaseSalesDate = $('#purchaseSalesDate').val()
        }
      })
    },
    setEnglishDate() {
      this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    searchItem(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredItems = [...this.itemMasterListByItemType]
        } else {
          this.filteredItems = this.itemMasterListByItemType.filter((item) => {
            return item.name.toLowerCase().includes(event.query.toLowerCase()) || item.itemCode.includes(event.query)
          })
        }
      }, 250)
    },
    focusInput() {
      this.$refs.itm.focus()
    },
    focusAfterSave() {
      this.$refs.tran.focus()
    },
    goBack() {
      if (this.inventoryInOutDetailDeleteList.length > 0) {
        this.purchaseReturn.inventoryInOutDetailList = this.inventoryInOutDetailDeleteList
      }
      this.$router.back()
    },
    chooseDisPercent() {
      this.chooseDiscountPer = false
      this.chooseDiscountAmt = true
      this.discountPer = 0
    },
    chooseDisountAmt() {
      this.chooseDiscountAmt = false
      this.chooseDiscountPer = true
      this.discountAmt = 0
    }
  },
  components: {
    Dropdown,
    DatePicker,
    AutoComplete,
    InputNumber,
    InputMask,
    InputText,
    Button,
    Textarea
  }
}
</script>

<style scoped src="@../../../static/css/purchase.css">
</style>



// WEBPACK FOOTER //
// purchasereturn.vue?b9c54c1c